<!-- Header -->
<template>
  <div class="component-header">
    <!-- 背景图 开始 -->
    <img src="../assets/images/bg.png" class="banner" />
    <!-- 背景图 结束 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ComponentBgimg",
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex" // 当前激活的导航菜单的下标
    ])
  },
  methods: {
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.component-header {
  position: relative;
  min-width: 1200px;
}

.banner {
  display: block;
  width: 100%;
  height: 5800px;
}
</style>



// WEBPACK FOOTER //
// src/components/bg.vue